import type { Emitter } from "mitt";
import mitt from "mitt";
import type { Events } from "./types";

export const emitter: Emitter<Events> = mitt<Events>();
